import React, { Component } from "react";
import { TextInput } from "react-input-with-keyboard";
import "react-input-with-keyboard/dist/index.css";
import { withTranslation } from "react-i18next";
import "./style.scss";
class InputKeyboardClass extends Component {
  render() {
    let {
      id,
      placeholder,
      value,
      containerClassName,
      keyboardKeyClassName,
      onChange,
      size = "small",
      textStyles,
      onFocus,
      className,
      fullKeyboard = true,
      type,
    } = this.props;
    return (
      <div id="inputKeyboardContainer">
        <TextInput
          id={id}
          className={className}
          placeholder={placeholder}
          value={value}
          containerClassName={containerClassName}
          keyboardKeyClassName={keyboardKeyClassName}
          onChange={onChange}
          size={size}
          textStyles={textStyles}
          onFocus={onFocus}
          fullKeyboard={fullKeyboard}
          type={type}
        />
      </div>
    );
  }
}

export const InputKeyboard = withTranslation()(InputKeyboardClass);
